"use client";

import * as React from "react";
import { Badge, CustomTooltip } from "@akashnetwork/ui/components";
import { cn } from "@akashnetwork/ui/utils";
import { useServices } from "@src/context/ServicesProvider";
import { useTrialDeploymentTimeRemaining } from "@src/hooks/useTrialDeploymentTimeRemaining";
import { TrialDeploymentTooltip } from "./TrialDeploymentTooltip";
export type Props = {
  createdHeight?: number;
  trialDurationHours?: number;
  averageBlockTime?: number;
  className?: string;
  dependencies?: typeof DEPENDENCIES;
};
export const DEPENDENCIES = {
  Badge,
  CustomTooltip,
  TrialDeploymentTooltip,
  useTrialTimeRemaining: useTrialDeploymentTimeRemaining
};
export function TrialDeploymentBadge({
  createdHeight,
  trialDurationHours,
  averageBlockTime = 6,
  className,
  dependencies: d = DEPENDENCIES
}: Props) {
  const {
    publicConfig
  } = useServices();
  const trialDuration = trialDurationHours ?? publicConfig.NEXT_PUBLIC_TRIAL_DEPLOYMENTS_DURATION_HOURS;
  const {
    isExpired,
    timeRemainingText
  } = d.useTrialTimeRemaining({
    createdHeight,
    trialDurationHours: trialDuration,
    averageBlockTime
  });
  return <d.CustomTooltip title={<d.TrialDeploymentTooltip createdHeight={createdHeight} isExpired={isExpired} timeRemainingText={timeRemainingText} trialDuration={trialDuration} />} data-sentry-element="d.CustomTooltip" data-sentry-component="TrialDeploymentBadge" data-sentry-source-file="TrialDeploymentBadge.tsx">
      <div className="inline-flex items-center gap-1">
        <d.Badge variant={isExpired ? "destructive" : "info"} className={cn("inline-flex cursor-help items-center gap-1", className)} data-sentry-element="d.Badge" data-sentry-source-file="TrialDeploymentBadge.tsx">
          <span>Trial</span>
        </d.Badge>
      </div>
    </d.CustomTooltip>;
}